import api from '@/api/purchase';
import store from '@/store';
import { resolve } from 'path';

// eslint-disable-next-line no-shadow
const getExchangeRate = (context, data) => new Promise(((resolve, reject) => {
  api.getExchangeRate(data)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
      reject(error);
    });
}));

// eslint-disable-next-line no-shadow
const saveExchangeRate = (context, value) => new Promise((resolve, reject) => {
  context.commit('SAVE_EXCHANGE_RATE', value);
});

// eslint-disable-next-line no-shadow
const getProductList = context => new Promise((resolve, reject) => {
  api.getProductList()
    .then((response) => {
      resolve(response);
    })
    .catch(error => reject(error));
});

// eslint-disable-next-line no-shadow
const getBraintreeClientToken = (context, config) => new Promise((resolve, reject) => {
  api.getBraintreeClientToken(config)
    .then((response) => {
      context.commit('SAVE_BRAINTREE_CLIENT_TOKEN_RESPONSE', response.response);
      resolve(response);
    })
    .catch(error => reject(error));
});

// eslint-disable-next-line no-shadow
const verifyBraintreePayment = (context, config) => new Promise((resolve, reject) => {
  api.verifyBraintreePayment(config)
    .then((response) => {
      if (response.response.errors && response.response.errors.length > 0) {
        reject(response.response.errors);
      }
      resolve(response);
    })
    .catch(error => reject(error));
});

// eslint-disable-next-line no-shadow
const setBraintreeResponse = (context, obj) => new Promise((resolve, reject) => {
  context.commit('SAVE_BRAINTREE_RESPONSE', obj);
});

// eslint-disable-next-line no-shadow
const getCountryList = context => new Promise((resolve, reject) => {
  api.getCountryList()
    .then((response) => {
      context.commit('SAVE_COUNTRIES', response);
      resolve(response);
    })
    .catch(error => reject(error));
});

// eslint-disable-next-line no-shadow
const setPlanStateInfos = (context, obj) => new Promise((resolve, reject) => {
  context.commit('SAVE_PLAN_STATE_INFOS', obj);
});

// eslint-disable-next-line no-shadow
const setBillingStateInfos = (context, obj) => new Promise((resolve, reject) => {
  context.commit('SAVE_BILLING_STATE_INFOS', obj);
});

// eslint-disable-next-line no-shadow
const sendEnquiry = (context, payload) => new Promise((resolve, reject) => {
  api.sendEnquiry(payload)
    .then((response) => {
      resolve(response);
    })
    .catch(error => reject(error));
});

// eslint-disable-next-line no-shadow
const checkPreviousPurchase = (context, email) => new Promise((resolve, reject) => {
  api.checkPreviousPurchase(email)
    .then((response) => {
      resolve(response);
    })
    .catch(error => reject(error));
});

// eslint-disable-next-line no-shadow
const initiateCustomerAuth = (context, email) => new Promise((resolve, reject) => {
  api.initiateCustomerAuth(email)
    .then((response) => {
      resolve(response);
    })
    .catch(error => reject(error));
});

// eslint-disable-next-line no-shadow
const pollCustomerAuth = (context, requestToken) => new Promise((resolve, reject) => {
  api.pollCustomerAuth(requestToken)
    .then((response) => {
      resolve(response);
    })
    .catch(error => reject(error));
});

// eslint-disable-next-line no-shadow
const getPurchasesList = (context, { page, orderKey, direction, limit }) => new Promise((resolve, reject) => {
  api.getPurchasesList(page, orderKey, direction, limit)
    .then((response) => {
      resolve(response);
    })
    .catch(error => reject(error));
});

const getCouponsForPurchase = (context, { purchaseId, orderKey, direction, term }) =>
// eslint-disable-next-line no-shadow
  new Promise(((resolve, reject) => {
    api.getCouponsForPurchase(purchaseId, orderKey, direction, term)
      .then((response) => {
        resolve(response);
      })
      .catch(error => reject(error));
  }));

// eslint-disable-next-line no-shadow
const revokeCoupon = (conext, { purchaseId, coupons }) => new Promise((resolve, reject) => {
  api.revokeCoupon(purchaseId, coupons)
    .then((response) => {
      resolve(response);
    })
    .catch(error => reject(error));
});

// eslint-disable-next-line no-shadow
const redeemCoupon = (conext, { purchaseId, data }) => new Promise((resolve, reject) => {
  api.redeemCoupon(purchaseId, data)
    .then((response) => {
      resolve(response);
    })
    .catch(error => reject(error));
});

export default {
  getExchangeRate,
  saveExchangeRate,
  getCountryList,
  setPlanStateInfos,
  setBillingStateInfos,
  getProductList,
  getBraintreeClientToken,
  verifyBraintreePayment,
  setBraintreeResponse,
  sendEnquiry,
  checkPreviousPurchase,
  initiateCustomerAuth,
  pollCustomerAuth,
  getPurchasesList,
  getCouponsForPurchase,
  revokeCoupon,
  redeemCoupon
};



// WEBPACK FOOTER //
// ./src/store/modules/purchase/actions.js